<template>
    <BaseSection width="page-narrow" class="section--team-members">
        <template #title>{{ title }}</template>
        <div v-for="(item, index) in subtitleTeamMembers" :key="index" class="section--team-members__subsection">
            <h3 class="section--team-members__subtitle">{{ item.subTitle }}</h3>
            <ContactCard
                v-for="(teamMember, i) in item.teamMembers"
                :key="i"
                :team-member="teamMember"
            />
        </div>
    </BaseSection>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: ''
    },
    subtitleTeamMembers: {
        type: Array,
        required: true
    }
});
</script>

<style lang="less">
    .section--team-members {
        .section--team-members__subsection {
            &:not(:first-child) {
                margin-top: 2rem;
            }
        }

        .section__body {
            max-width: var(--grid-maxWidth-content);
        }

        .section__title {
            .typography-h3();
        }

        .section--team-members__subtitle {
            .typography-text();
            margin-bottom: 1rem;
        }

        .contact-card {
            &:not(:last-child) {
                margin-bottom: 1rem;

                @media @q-md-min {
                    margin-bottom: 2rem;
                }
            }

        }
    }
</style>
